// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontBold, fontCondensed, fontNormal } from "@fdr/static-ui/Typography";

import ButtonDefault from "../../_atoms/ButtonDefault";
import Tag from "../../_atoms/Tag";

export const RunnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  ${({ scratched }) =>
    scratched &&
    css`
      opacity: 0.5;
    `};

  &:active {
    ${(props) =>
      props.showActiveState &&
      `background-color: ${buildColor("grey", "100")}`};
  }

  &:last-child {
    border-bottom: 0 none;
  }
`;

export const RunnerInfo = styled.div`
  display: flex;
  ${({ isNumberFireSection, numberFire }) =>
    isNumberFireSection || !numberFire
      ? css`
          padding-top: 12px;
        `
      : css`
          padding: 12px 0;
        `};
  ${({ addMarginBottom }) =>
    addMarginBottom &&
    css`
      margin-bottom: 17px;
    `};
  align-items: flex-start;
  justify-content: space-between;
`;

export const AnyButton = styled(ButtonDefault)`
  width: 100%;
  flex: 1 1 auto;
  border-radius: 0 3px 3px 0;
  ${({ isChecked }) =>
    isChecked
      ? css`
          color: ${buildColor("white", "100")};
          background-color: ${buildColor("blue", "500")};
        `
      : css`
          color: ${buildColor("blue", "500")};
          background-color: ${buildColor("white", "100")};
        `};
  font-size: 14px;
  position: relative;
  height: 46px;
  ${({ isGroup }) =>
    isGroup &&
    css`
      padding: 0 5px;
    `}
`;

export const RunnerSelectionWrapped = styled.div`
  display: flex;
  margin-right: 12px;
  align-items: flex-end;
  justify-content: flex-end;
  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}

  & > span:last-child {
    margin-right: 0;
  }

  ${({ isBorderActive }) =>
    isBorderActive &&
    css`
      border: 1px solid ${buildColor("blue", "500")};
      border-radius: 4px;
    `};
  ${({ vertical }) =>
    vertical
      ? css`
          min-height: 0;
          padding-bottom: 12px;
        `
      : css`
          min-height: 46px;
        `}
`;

export const JockeySilk = styled.img`
  width: 34px;
  height: 35px;
  ${({ isSilkLoaded }) => {
    return (
      !isSilkLoaded &&
      css`
        opacity: 0;
      `
    );
  }};
`;

export const JockeySilkContainer = styled.div`
  ${({ hasTimeformInfo }) =>
    hasTimeformInfo
      ? css`
          align-items: flex-start;
          margin-right: 12px;
          margin-left: 12px;
        `
      : css`
          align-items: center;
        `};
  width: 42px;
  height: 43px;
  display: flex;
  position: relative;
  justify-content: center;
`;

export const RunnerJockeyWrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
`;

export const BetSection = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  ${({ isScratched }) =>
    isScratched &&
    css`
      justify-content: center;
    `};
`;

export const RunnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const RunnerInfoContainer = styled.dl`
  display: flex;
  position: relative;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  ${({ isNumberFireSection }) =>
    isNumberFireSection &&
    css`
      height: 40px;
      justify-content: space-evenly;
    `};
  height: fit-content;
  width: 100%;
  padding-right: 20px;
`;

export const HorseDescription = styled.dt`
  position: relative;
  display: inline-flex;
  align-items: center;
  ${({ isNumberFireSection }) =>
    !isNumberFireSection &&
    css`
      margin-bottom: 4px;
    `}
`;

export const CoupledTagContainer = styled.div`
  position: absolute;
  right: -59px;
`;

export const DriverDescription = styled.dd`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-family: ${fontNormal};
  color: ${buildColor("grey", "800")};
  margin-right: 12px;
`;

export const OddsContainer = styled.dl`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  white-space: nowrap;
  margin-right: 16px;
  margin-left: 16px;
`;

export const OddInfo = styled.dt`
  display: flex;
  flex-direction: row;
  color: ${buildColor("grey", "900")};
  font-family: ${fontBold};
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 4px;
  ${({ hasTrending }) =>
    !hasTrending
      ? css`
          & > :nth-child(n) {
            margin-right: 6px;
          }
        `
      : css`
          & > :nth-child(n) {
            margin-right: 4px;
          }
        `};
`;

const getBorderWidth = ({ hasBiggerBottomBorder, hasTimeformInfo }) => {
  let width;
  if (hasBiggerBottomBorder) {
    width = "12px";
  } else if (hasTimeformInfo) {
    width = "54px";
  } else {
    width = "42px";
  }

  return css`
    width: calc(100% - ${width});
  `;
};

export const RunnerLineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 12px;
  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      background-color: ${buildColor("grey", "000")};
    `};

  &.hasBottomBorder::after {
    content: "";
    display: flex;
    margin-left: auto;
    ${getBorderWidth}
    ${({ isOpen }) =>
      !isOpen
        ? css`
            border-bottom: ${({ hasDashedBorder }) =>
              hasDashedBorder ? `2px dashed` : `1px solid`};
            border-bottom-color: ${buildColor("grey", "300")};
            transition: border-bottom-color 0.2s linear 0.35s;
          `
        : css`
            border-bottom: ${({ hasDashedBorder }) =>
              hasDashedBorder ? `2px dashed` : `1px solid`};
            border-bottom-color: ${buildColor("white", "100")};
            transition: border-bottom-color 0s linear;
          `};
  }
`;

export const ExoticBetting = styled.div`
  ${({ fullWidth }) =>
    fullWidth
      ? css`
          margin: 0 12px 12px;
        `
      : css`
          margin-left: 56px;
          margin-bottom: 12px;
        `}
`;

export const NumberFire = styled.div`
  margin: ${({ hasTimeformInfo }) =>
    hasTimeformInfo ? "0 0 12px 54px" : "0 0 12px 42px"};
  display: flex;
  justify-content: flex-start;
  align-items: ${({ isRAS }) => (isRAS ? "center" : "flex-start")};
  font-size: 12px;
  font-family: ${fontCondensed};
  color: ${buildColor("grey", "800")};
  letter-spacing: 1px;
  text-transform: uppercase;
  ${({ isRAS }) =>
    !isRAS &&
    css`
      & > svg {
        width: 58px;
        height: 14px;
      }
    `}

  & > svg {
    margin-right: 3px;
  }
`;

export const NumberFirePick = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  text-transform: uppercase;
  font-size: 12px;
  line-height: 14px;
  font-family: ${fontCondensed};
  color: ${buildColor("grey", "800")};
  letter-spacing: 1px;
`;

export const NumberFireComment = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 125%;
  display: flex;
  align-items: center;
  color: ${buildColor("grey", "800")};
`;

export const HorseName = styled.span`
  position: relative;
  font-size: 14px;
  font-family: ${fontBold};
  font-weight: 500;
  color: ${buildColor("grey", "900")};
  text-overflow: ellipsis;
  white-space: break-spaces;
  word-break: break-all;
`;

export const ScratchedTag = styled(Tag)`
  margin-right: 12px;
`;

export const WinProb = styled.span`
  color: ${buildColor("grey", "800")};
  font-size: 12px;
  font-family: ${fontCondensed};
  margin-right: 12px;
  margin-top: 6px;
  height: 16px;
  vertical-align: bottom;
  display: flex;
  align-items: flex-end;
  white-space: nowrap;

  & > span {
    font-size: 14px;
    color: ${buildColor("grey", "900")};
    font-family: ${fontNormal};
    margin-left: 2px;
  }
`;

export const GroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HorseNameOnboardingTooltip = styled.div`
  position: absolute;
  display: flex;
  justify-content: space-between;
  font-family: ${fontCondensed};
  letter-spacing: 1.03px;
  font-size: 12px;
  text-transform: uppercase;
  background-color: ${buildColor("navy", "500")};
  color: ${buildColor("white", "100")};
  align-items: center;
  padding: 8px;
  top: -30px;
  right: -56px;
  width: 96px;
  border-radius: 2px;

  &::before {
    position: absolute;
    left: calc(50% - 4px);
    bottom: -4px;
    content: "";
    width: 0;
    height: 0;
    border-width: 4px 4px 0;
    border-color: ${buildColor("navy", "500")} transparent transparent
      transparent;
    border-style: solid;
  }
`;

export const Odd = styled.span`
  font-size: 10px;
  font-family: ${fontNormal};
  color: ${buildColor("grey", "900")};
  margin-left: 4px;
`;

export const USOdds = styled.div`
  font-family: ${fontCondensed};
  font-size: 12px;
  letter-spacing: normal;
  text-transform: uppercase;
  color: ${buildColor("grey", "800")};
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  margin: 6px 12px 8px 0;
  width: max-content;

  & > svg {
    margin-right: -4px;
  }
`;

export const USOddsContainer = styled.div``;

export const USOddsText = styled.div``;

export const ExpandIconWrapper = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${buildColor("grey", "L5")};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 4px;
`;
